// extracted by mini-css-extract-plugin
export default {"subscriptionCardsContainer":"Bimg5DDtQtg8Pc3qKxQc"};